import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getGstNumberList,
  getGstrTwoATwoBCompareListAction,
  getGstrTwoBReturnsListAction,
  requestGstOtpAction,
  resetGstMessage,
  resetGstModuleError,
  resetGstModuleFetching,
  resetGstModuleSuccess,
  resetGstOtpMessage,
  resetGstOtpVerifyMessage,
  resetGstrTwoAReturnsData,
  resetGstrTwoBReturnsData,
  verifyGstOtpAction,
} from "../../../redux/gstModule";
import { resetSession } from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import { EmptyListPage, ErrorSuccessModal, TableLoader } from "../../commons";
import { NoFile } from "../../../assets/images";
import { BusinessAddressListType } from "../../../redux/clientSettings/clientSettingTypes";
import { GetAllBussinessAddressesListPayloadType } from "../../../commonTypes/clientSettingsTypes";
import {
  getAllBusinessAddressAction,
  resetBusinessAddressList,
} from "../../../redux/clientSettings";
import { useParams } from "react-router-dom";
import OtpModal from "../common/OtpModal";
import {
  GetGstNumberPayload,
  GetGstrTwoATwoBComparePayloadType,
  GetGstrTwoBListPayloadType,
  GstNumberType,
  GstrTwoBDataType,
  RequestGstOtpPayloadType,
  VerifyGstOtpPayloadType,
} from "../../../commonTypes/gstTypes";
import moment from "moment";
import GstrTwoATwoBHeader from "../common/GstrTwoATwoBHeader";
import toast, { Toaster } from "react-hot-toast";
import { downloadGST2BReportsApi } from "../../../apis/gstModuleApis";
import FileSaver from "file-saver";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import GstrTwoBTableData from "../common/GstTwoBTableData";
import ValidateGST from "../../commons/ValidateGST/ValidateGST";
import { getMonthNumber } from "../../../utils/commonFunctions";
import GstrTwo2BAccordian from "./GstrTwo2BAccordian";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null | undefined;
  statusCode: number | null;
  message: string | null;
  businessAddressList: [] | BusinessAddressListType[];
  gstrTwoBReturnsData: [] | GstrTwoBDataType[] | any;
  dispatchResetSession: () => void;
  dispatchResetGstError: () => void;
  dispatchResetGstSuccess: () => void;
  dispatchResetGstFetching: () => void;
  dispatchResetGstMessage: () => void;
  dispatchResetGstrTwoBData: () => void;
  dispatchResetBusinessAddressList: () => void;
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchVerifyGstOtp: (data: VerifyGstOtpPayloadType) => void;
  dispatchRequestGstOtp: (data: RequestGstOtpPayloadType) => void;
  dispatchGetGstTwoBData: (data: GetGstrTwoBListPayloadType) => void;
  dispatchResetGstrTwoAData: () => void;
  dispatchGetGstNumber: (data: GetGstNumberPayload) => void;
  gstNumberList: GstNumberType[] | [];
  dispatchResetGstOtpMessage: () => void;
  dispatchResetGstOtpVerifyMessage: () => void;
  gstOtpVerifyMessage: null | string;
  gstOtpMessage: null | string;
  fetchFromGstPortal: number;
  dispatchGetGstTwoATwoBCompareData: (
    data: GetGstrTwoATwoBComparePayloadType
  ) => void;
};

const GstrTwoB = ({
  history,
  token,
  fetching,
  success,
  error,
  statusCode,
  message,
  businessAddressList,
  gstrTwoBReturnsData,
  dispatchResetSession,
  dispatchResetGstError,
  dispatchResetGstSuccess,
  dispatchResetGstFetching,
  dispatchResetGstMessage,
  dispatchRequestGstOtp,
  dispatchVerifyGstOtp,
  dispatchGetGstTwoBData,
  dispatchResetGstrTwoBData,
  dispatchResetBusinessAddressList,
  dispatchGetAllBusinessAddressList,
  dispatchResetGstrTwoAData,
  dispatchGetGstNumber,
  gstNumberList,
  dispatchResetGstOtpMessage,
  dispatchResetGstOtpVerifyMessage,
  gstOtpVerifyMessage,
  gstOtpMessage,
  fetchFromGstPortal,
  dispatchGetGstTwoATwoBCompareData,
}: AppProps) => {
  const { id } = useParams<any>();
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : id
      ? id
      : null;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : null;
  const { gstNumber, historySelectedMonths, year } = history?.location?.state;

  const [data, setData] = useState<GstrTwoBDataType[] | []>([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [offset, setOffset] = useState<number>(0);
  const [gstDetails, setGstDetails] = useState({
    label: "Select...",
    value: undefined,
    userName: undefined,
    legalName: undefined,
    tradeName: undefined,
  });
  const [isOtpModal, setIsOtpModal] = useState<boolean>(false);
  const [activeStatus, setActiveStatus] = useState("");
  const [activeStatusValue, setActiveStatusValue] = useState<string>("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [isReportsDownloadPresent, setIsReportsDownloadPresent] =
    useMenuCheck();
  const [isShowMissingInvoices,setIsShowMissingInvoices] = useMenuCheck();
  const [showMissingInvoices, setShowMissingInvoices] = useState(false);
  useEffect(() => {
    setData([]);
    dispatchResetGstOtpMessage();
    dispatchResetGstOtpVerifyMessage();
    dispatchResetGstError();
    dispatchResetGstSuccess();
    dispatchResetGstFetching();
    dispatchResetGstMessage();
    dispatchResetGstrTwoBData();
    dispatchResetGstrTwoAData();
    dispatchResetBusinessAddressList();
    setIsReportsDownloadPresent("GSTR 2B Reports Download", "menu");
    setIsShowMissingInvoices("GSTR 2B Show Missing Invoices", "menu");
    dispatchGetAllBusinessAddressList({ token, client_code });
    dispatchGetGstNumber({ token, client_code });
  }, []);

  useEffect(() => {
    if (selectedMonths?.length === 0) {
      setData([]);
    }
  }, [selectedMonths]);

  useEffect(() => {
    if (gstNumber) {
      setGstDetails({
        ...gstDetails,
        value: gstNumber,
        label: gstNumber,
      });
    }
    if (historySelectedMonths?.length) {
      setSelectedMonths(historySelectedMonths);
      setShowMissingInvoices(true);
    }
    if (year) {
      setSelectedYear(year);
    }
  }, [gstNumber, historySelectedMonths, year]);

  useEffect(() => {
    if (gstrTwoBReturnsData?.length) {
      setData(gstrTwoBReturnsData);
    } else {
      setData([]);
    }
  }, [gstrTwoBReturnsData]);

  useEffect(() => {
    if (clearFilter) {
      setActiveStatus("");
      setActiveStatusValue("");
      setClearFilter(false);
    }
  }, [clearFilter]);

  // const isGstrTwoBDataType = (data: any): data is GstrTwoBDataType => {
  //   return data?.document_details && typeof data === "object";
  // };

  const addingIsOpenForTwoB = () => {
    if (gstrTwoBReturnsData?.length) {
      const updatedData = gstrTwoBReturnsData.map((el: any) => {
        const updatedInvoices = Object.keys(el.data).reduce(
          (acc: { [key: string]: any }, key) => {
            const invoices = el.data[key];
            if (Array.isArray(invoices)) {
              acc[key] = invoices.map((item) => ({
                ...item,
                isOpen: false,
              }));
            } else {
              acc[key] = invoices;
            }
            return acc;
          },
          {}
        );

        return {
          ...el,
          data: updatedInvoices,
        };
      });

      setData(updatedData);
    }
  };

  useEffect(() => {
    if (gstrTwoBReturnsData) {
      addingIsOpenForTwoB();
    }
  }, [gstrTwoBReturnsData]);

  let branchOption = gstNumberList?.map((item: any) => {
    return {
      label: item.gst_number,
      value: item?.gst_number,
      gstUsername: item?.gst_username,
      gstIn: item?.gst_number,
      legalName: item?.legal_name,
      tradeName: item?.trade_name,
      registrationDate: item?.registration_date,
      registrationType: item?.registration_type,
      companyStatus: item?.company_status,
      constitutionOfBusiness: item?.constitution_of_business,
    };
  });

  const toggleModal = () => {
    setIsOtpModal(!OtpModal);
  };

  const handleApply = () => {
    if (gstDetails?.label?.length && !showMissingInvoices) {
      dispatchResetGstrTwoBData();
      setData([]);
      dispatchResetGstMessage();
      const monthNumbers = selectedMonths
        .map((item: any) => {
          const [month] = item.split(" ");
          const monthAbbreviation = month.slice(0, 3).toUpperCase(); // Get first 3 letters in uppercase
          const monthNumber = getMonthNumber(monthAbbreviation);

          return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;
        })
        .sort();
      let finalData = {
        gstNumber: gstDetails?.label,

        token,
        clientCode: client_code,
        // year: moment(selectedDate)?.format("MM/yyyy")?.split("/")[1],
        // month: moment(selectedDate)?.format("MM/yyyy")?.split("/")[0],
        year: selectedYear,
        month: monthNumbers?.join(),
        fetchFromGstPortal: 0,
      };
      dispatchGetGstTwoBData(finalData);
    } else if (gstDetails?.label?.length && showMissingInvoices) {
      dispatchResetGstrTwoAData();
      setData([]);
      dispatchResetGstMessage();

      const monthNumbers = selectedMonths
        .map((item: any) => {
          const [month] = item.split(" ");
          const monthAbbreviation = month.slice(0, 3).toUpperCase(); // Get first 3 letters in uppercase
          const monthNumber = getMonthNumber(monthAbbreviation);

          return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;
        })
        .sort();

      let finalData = {
        gstNumber: gstDetails?.label,
        token,
        clientCode: client_code,
        year: selectedYear,
        month: monthNumbers?.join(),
        type: "2b",
      };

      dispatchGetGstTwoATwoBCompareData(finalData);
    }
  };

  const handleRefreshApply = () => {
    if (gstDetails?.label?.length) {
      dispatchResetGstrTwoBData();
      setData([]);
      dispatchResetGstMessage();
      const monthNumbers = selectedMonths
        .map((item: any) => {
          const [month] = item.split(" ");
          const monthAbbreviation = month.slice(0, 3).toUpperCase(); // Get first 3 letters in uppercase
          const monthNumber = getMonthNumber(monthAbbreviation);

          return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;
        })
        .sort();
      let finalData = {
        gstNumber: gstDetails?.label,

        token,
        clientCode: client_code,
        // year: moment(selectedDate)?.format("MM/yyyy")?.split("/")[1],
        // month: moment(selectedDate)?.format("MM/yyyy")?.split("/")[0],
        year: selectedYear,
        month: monthNumbers?.join(),
        fetchFromGstPortal: 1,
      };
      dispatchGetGstTwoBData(finalData);
    }
  };

  const handlePrepareGST2BReportData = () => {
    const monthNumbers = selectedMonths
      .map((item: any) => {
        const [month] = item.split(" ");
        const monthAbbreviation = month.slice(0, 3).toUpperCase(); // Get first 3 letters in uppercase
        const monthNumber = getMonthNumber(monthAbbreviation);

        return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;
      })
      .sort();
    let params = {
      token,
      client_code: client_code,
      gst_number: gstDetails?.label,
      // year: moment(selectedDate)?.format("MM/yyyy")?.split("/")[1],
      // month: moment(selectedDate)?.format("MM/yyyy")?.split("/")[0],
      year: selectedYear,
      month: monthNumbers?.join(),
      fetch_from_gst_portal: fetchFromGstPortal,
    };

    if (params && token) {
      handleDownloadGst2BReport(params);
    }
  };

  const handleDownloadGst2BReport = (params: any) => {
    let reportName = `${client_code ? client_code : ""}_${
      company_name ? company_name : "reports"
    }_GSTR2B_${moment(selectedDate)?.format("MM/yyyy")}.xlsx`;

    downloadGST2BReportsApi(params).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handleCompareAddInvoice = (invoiceNumber: string,month:string) => {
    history.push(
      `/invoice-generation/add-gst-compare/${client_code}?type=expenses`,
      {
        client_code,
        company_name,
        gstClientCode: client_code,
        gstNumber: gstDetails?.label,
        year: selectedYear,
        month:month?.split("-")?.[0],
        gstType: "2b",
        gstInvoiceNumber: invoiceNumber,
        selectedMonths,
        selectedYear,
        // data_type: selectDataType?.value,
      }
    );
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
            }}
            statusCode={statusCode}
          />
        );
      } else if (
        error !==
          "Please complete the OTP verification steps to access GST APIs!" &&
        error &&
        error &&
        statusCode !== 401
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetGstError();
              dispatchResetGstMessage();
            }}
          />
        );
      }
    }
    return false;
  };
  const checkDataLength = () => {
    let flag = true;
    if (showMissingInvoices) {
      data?.forEach((item: any) => {
        const arr: any[] =!item?.is_error_occured? Object?.values(item?.data?.document_details):[];

        arr.forEach((value) => {
          if (value.length > 0) {
            flag = false;
          }
        });
      });
    }
    return flag;
  };

  return (
    <div className="gst pb-3">
      <GstrTwoATwoBHeader
        // selectedDate={selectedDate}
        // setSelectedDate={setSelectedDate}
        handleRefreshApply={handleRefreshApply}
        setSelectedYear={setSelectedYear}
        selectedYear={selectedYear}
        setSelectedMonths={setSelectedMonths}
        selectedMonths={selectedMonths}
        gstDetails={gstDetails}
        fetching={fetching}
        gstrTwoBReturnsData={gstrTwoBReturnsData}
        option={branchOption}
        setGstDetails={setGstDetails}
        handleApply={handleApply}
        type="GstrTwoB"
        activeStatus={activeStatus}
        activeStatusValue={activeStatusValue}
        setActiveStatus={setActiveStatus}
        setClearFilter={setClearFilter}
        setActiveStatusValue={setActiveStatusValue}
        handlePrepareDownloadReportData={handlePrepareGST2BReportData}
        data={data}
        isReportsDownloadPresent={isReportsDownloadPresent}
        showMissingInvoices={showMissingInvoices}
        setShowMissingInvoices={setShowMissingInvoices}
        isShowMissingInvoices={isShowMissingInvoices}
      />
      {fetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      ) : (!showMissingInvoices && data?.length) ||
        (showMissingInvoices && !checkDataLength()) ? (
        <GstrTwo2BAccordian
          type="gstrone"
          data={data}
          setData={setData}
          showMissingInvoices={showMissingInvoices}
          handleCompareAddInvoice={handleCompareAddInvoice}
        />
      ) : (
        <>
          {!fetching &&
            data &&
            (checkDataLength() || Object.keys(data)?.length === 0) && (
              <div className="pb-5 pt-5">
                <EmptyListPage
                  title="No Records Found"
                  text="Choose GST Number to get GSTR-2B data."
                  image={NoFile}
                  imageWidth="30%"
                />
              </div>
            )}
        </>
      )}

      {error ===
        "Please complete the OTP verification steps to access GST APIs!" &&
      statusCode === 500 ? (
        <ValidateGST
          clientCode={client_code}
          gstDetails={gstDetails}
          history={history}
        />
      ) : null}
      <Toaster />
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
  error: state.gst.error,
  success: state.gst.success,
  message: state.gst.message,
  statusCode: state.gst.statusCode,
  businessAddressList: state.clientSettings.businessAddressList,
  gstrTwoBReturnsData: state.gst.gstrTwoBReturnsData,
  gstNumberList: state.gst.gstNumberList,
  gstOtpMessage: state.gst.gstOtpMessage,
  gstOtpVerifyMessage: state.gst.gstOtpVerifyMessage,
  fetchFromGstPortal: state.gst.fetchFromGstPortal,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetGstError: () => dispatch(resetGstModuleError()),
  dispatchResetGstSuccess: () => dispatch(resetGstModuleSuccess()),
  dispatchResetGstFetching: () => dispatch(resetGstModuleFetching()),
  dispatchResetGstMessage: () => dispatch(resetGstMessage()),
  dispatchResetGstrTwoBData: () => dispatch(resetGstrTwoBReturnsData()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchVerifyGstOtp: (data: VerifyGstOtpPayloadType) =>
    dispatch(verifyGstOtpAction(data)),
  dispatchRequestGstOtp: (data: RequestGstOtpPayloadType) =>
    dispatch(requestGstOtpAction(data)),
  dispatchGetGstTwoBData: (data: GetGstrTwoBListPayloadType) =>
    dispatch(getGstrTwoBReturnsListAction(data)),
  dispatchResetGstrTwoAData: () => dispatch(resetGstrTwoAReturnsData()),
  dispatchGetGstNumber: (data: GetGstNumberPayload) =>
    dispatch(getGstNumberList(data)),
  dispatchResetGstOtpMessage: () => dispatch(resetGstOtpMessage()),
  dispatchResetGstOtpVerifyMessage: () => dispatch(resetGstOtpVerifyMessage()),
  dispatchGetGstTwoATwoBCompareData: (
    data: GetGstrTwoATwoBComparePayloadType
  ) => dispatch(getGstrTwoATwoBCompareListAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GstrTwoB);
